import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { getIndividualReportRequest } from '../services/individualReport';
import { useLangManagement } from './useLangManagement';

export const useIndividualReport = () => {
  const { slug } = useParams();

  const { currentLang } = useLangManagement();

  const getIndividualReport = useCallback(async () => {
    if (slug) {
      return await getIndividualReportRequest(slug);
    }

    return null;
  }, [slug]);

  return {
    currentLang,
    getIndividualReport,
  };
};
